<template>
  <div>
    <div class="flex flex-col gap-y-10 pt-12 pb-16 px-4 xs:px-8 md:px-4 xl:px-8">
      <!-- Seção visão geral estatísticas -->
      <section v-if="false">
        <ul class="flex flex-wrap justify-between gap-y-4 md:gap-x-1f lg:gap-x-2">
          <li
            v-for="(overview, index) in dataOverview"
            :key="index"
            class="w-full md:w-[24.4%] lg:w-[24%] md:h-24 flex justify-between items-center bg-white shadow-lg p-3 md:px-5 rounded-md border-t-2 border-sea-serpent hover:text-white hover:bg-sea-serpent"
          >
            <span>
              <h1
                class="mb-1 text-xl xl:text-3xl font-semibold text-oxford-blue hover:text-white"
              >
                {{ overview.number }}
              </h1>
              <RouterLink
                :to="`/dashboard/recruiter/${slug}/settings`"
                class="text-sm font-normal"
                >{{ overview.name }}
              </RouterLink>
            </span>
            <i class="pi pi-briefcase" style="font-size: 1.5rem"></i>
          </li>
        </ul>
      </section>
      <!-- Seção gráficos -->
      <DashboardCharts class="hidden" />

      <!-- Seção vagas recentes -->
      

      <!-- Seção Candidatos Recomendados -->
      <ApplicantsRecomendation class="hidden" />
      <section class="w-full"></section>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { RouterLink } from "vue-router";

import DashboardCharts from "@/components/Dashboard/DashboardCharts.vue";
import ApplicantsRecomendation from "@/components/Dashboard/Company/ApplicantsRecomendation.vue";


const store = useStore();
let slug = computed(() => store.state.user.slug);


onMounted(() => {});

const dataOverview = ref([]);
</script>
